import React from 'react';
import '../../css/BdStyles.css';

const BdSeries = () => {
    const series = [
        // Ejemplo de películas (puedes reemplazarlo con datos reales)
        { id: 1, title: 'Arkane', description: 'Descripción', tags: 'Animación, Fantasía, Steampunk', img_url: 'https://grupo.us.es/ligaincom/public/uploads/images/arkane.jpg' },
        { id: 2, title: 'The morning show', description: 'Descripción', tags: 'Feminismo, drama, comedia', img_url: 'https://grupo.us.es/ligaincom/public/uploads/images/morning_show.jpg' }
    ];

    return (
        <div className="container">
            <h2 className="title">Series</h2>
            <div className="row">
                {series.map(serie => (
                    <div key={serie.id} className="col-md-4 mb-4">
                        <div className="card">
                            <img src={serie.img_url} alt={serie.title} className="card-img-top" />
                            <div className="card-body">
                                <h5 className="card-title">{serie.title}</h5>
                                <p className="card-text">{serie.description}</p>
                                <small className="card-text">{serie.tags}</small>
                                <button className="btn btn-primary">Ver Detalle</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BdSeries;